import React from 'react';
import { Button } from '../ui/button';

interface RunJobButtonProps {
  step: number;
  approach: 'prediction' | 'similarity';
  labelColumn: string;
  positiveLabels: string[];
  onRunJob: () => void;
}

export const RunJobButton: React.FC<RunJobButtonProps> = ({
  step,
  approach,
  labelColumn,
  positiveLabels,
  onRunJob
}) => {
  const shouldShow = ((approach === 'prediction' && step >= 5) || (approach === 'similarity' && step >= 4)) && step < 6;
  
  if (!shouldShow) return null;

  return (
    <div className="flex justify-center py-6">
      <Button 
        onClick={onRunJob}
        className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white border-0 px-8 py-3 text-lg"
        disabled={approach === 'prediction' && (!labelColumn || positiveLabels.length === 0)}
      >
        Run It
      </Button>
    </div>
  );
}; 